export const ROLE = {
	USERS_CREATE: 'USERS_CREATE',
	USERS_READ: 'USERS_READ',
	USERS_UPDATE: 'USERS_UPDATE',
	ASSETS_CREATE: 'ASSETS_CREATE',
	ASSETS_READ: 'ASSETS_READ',
	ASSETS_UPDATE: 'ASSETS_UPDATE',
	ASSETS_DELETE: 'ASSETS_DELETE',
	INSPECTIONS_CREATE: 'INSPECTIONS_CREATE',
	INSPECTIONS_READ: 'INSPECTIONS_READ',
	INSPECTIONS_UPDATE: 'INSPECTIONS_UPDATE',
	INSPECTIONS_DELETE: 'INSPECTIONS_DELETE',
	ASSET_USERS_CREATE: 'ASSET_USERS_CREATE',
	ASSET_USERS_READ: 'ASSET_USERS_READ',
	ASSET_USERS_DELETE: 'ASSET_USERS_DELETE',
	SENSORS_READ: 'SENSORS_READ',
	SENSORS_TPS_TIMESERIES_READ: 'SENSORS_TPS_TIMESERIES_READ',
	SENSORS_TPS_PERFSTATS_READ: 'SENSORS_TPS_PERFSTATS_READ',
	SENSORS_TPS_SECTION_READ: 'SENSORS_TPS_SECTION_READ',
	SENSORS_MET_TIMESERIES_READ: 'SENSORS_MET_TIMESERIES_READ',
	DAMAGES_CREATE: 'DAMAGES_CREATE',
	DAMAGES_READ: 'DAMAGES_READ',
	DAMAGES_UPDATE: 'DAMAGES_UPDATE',
	DAMAGES_DELETE: 'DAMAGES_DELETE',
	POLYGONS_CREATE: 'POLYGONS_CREATE',
	POLYGONS_READ: 'POLYGONS_READ',
	POLYGONS_UPDATE: 'POLYGONS_UPDATE',
	POLYGONS_DELETE: 'POLYGONS_DELETE',
	FILES_UPLOAD: 'FILES_UPLOAD',
	SUB_ASSETS_CREATE: 'SUB_ASSETS_CREATE',
	SUB_ASSETS_READ: 'SUB_ASSETS_READ',
	SUB_ASSETS_UPDATE: 'SUB_ASSETS_UPDATE',
	SUB_ASSETS_DELETE: 'SUB_ASSETS_DELETE',
	DATA_UPLOADS_CREATE: 'DATA_UPLOADS_CREATE',
	DATA_UPLOADS_READ: 'DATA_UPLOADS_READ',
	DATA_UPLOADS_UPDATE: 'DATA_UPLOADS_UPDATE',
	DATA_UPLOADS_DELETE: 'DATA_UPLOADS_DELETE',
	WORK_PACKAGES_CREATE: 'WORK_PACKAGES_CREATE',
	WORK_PACKAGES_READ: 'WORK_PACKAGES_READ',
	WORK_PACKAGES_UPDATE: 'WORK_PACKAGES_UPDATE',
	WORK_PACKAGES_DELETE: 'WORK_PACKAGES_DELETE',
	ORGANIZATION_CREATE: 'ORGANIZATION_CREATE',
	ORGANIZATION_READ: 'ORGANIZATION_READ',
	ORGANIZATION_UPDATE: 'ORGANIZATION_UPDATE',
	ORGANIZATION_DELETE: 'ORGANIZATION_DELETE',
	APPCONFIG_DROPDOWNS_READ: 'APPCONFIG_DROPDOWNS_READ',
	INSPECTION_MANAGEMENT_PAGE_VIEW: 'INSPECTION_MANAGEMENT_PAGE_VIEW',
} as const;
export type ROLE = (typeof ROLE)[keyof typeof ROLE];
